import React from "react";
import OverviewKpiCard from "../../../components/Card/OverviewKpiCard";
import tasteIcon from "../../../assets/images/taste-rate.svg"
import Service_img from "../../../assets/images/service_dashb.svg"
import Ambiance_img from "../../../assets/images/ambiance_dashb.svg"
import Delivery_img from "../../../assets/images/delivery_dash.svg"

const PosPage = (props) => {
    const {data, showRatingView, type} = props;
    if(type === 'pos'){
      return <div className="flex flex_wrap p-1">
      <div>
        <OverviewKpiCard title={data?.aggregate_ratings?.taste_rating || 0} title2="Taste Rating" subview={`${data?.aggregate_ratings?.taste_rating_count || 0 } Reviews`} icon ={tasteIcon}
        showRatingView={showRatingView} className="min_kpi_card_size" />
      </div>
      <div>
        <OverviewKpiCard title={data?.aggregate_ratings?.ambience_rating || 0} title2="Ambience Rating" subview={`${data?.aggregate_ratings?.ambience_rating_count || 0 } Reviews`} icon ={Ambiance_img}
        showRatingView={showRatingView} className="min_kpi_card_size" />
      </div>
      <div>
        <OverviewKpiCard title={data?.aggregate_ratings?.service_rating || 0} title2="Service Rating" subview={`${data?.aggregate_ratings?.taste_rating_count || 0 } Reviews`} icon ={Service_img}
        showRatingView={showRatingView} className="min_kpi_card_size" />
      </div>
  </div>
    }
    return <div className="text-left flex flex_wrap p-1">
            <div>
              <OverviewKpiCard title={data?.aggregate_ratings?.taste_rating || 0} title2="Taste Rating" subview={`${data?.aggregate_ratings?.taste_rating_count || 0 } Reviews`} icon ={tasteIcon}
              showRatingView={showRatingView} className="min_kpi_card_size" />
            </div>
            <div>
              <OverviewKpiCard title={data?.aggregate_ratings?.delivery_rating || 0} title2="Delivery Rating" subview={`${data?.aggregate_ratings?.taste_rating_count || 0 } Reviews`} icon ={Delivery_img}
              showRatingView={showRatingView} className="min_kpi_card_size" />
            </div>
        </div>
};
export default PosPage;